import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { text, secondary } = theme.palette;

  return {
    trackSelectionTitle: {
      color: text.primary,
      fontSize: 22,
      paddingTop: 24,
      paddingBottom: 40,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        fontSize: 18
      },
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        fontSize: 17
      }
    },
    trackSelectionContent: {
      display: "flex",
      flexWrap: "wrap",
      gap: 10
    },
    button: {
      textTransform: "capitalize",
      padding: "12px 15px",
      height: 50,
      fontSize: 18,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        fontSize: 16,
        height: 44
      }
    },
    buttonActive: {
      backgroundColor: secondary.main,
      "&:hover": {
        backgroundColor: secondary.main
      }
    },
    horseSummaryRoot: {
      height: 118,
      padding: "14px 30px 26px 20px",
      marginTop: 15,
      filter: "drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.06))",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        height: "auto"
      }
    },
    horseSummaryInfo: {
      height: "100%",
      justifyContent: "space-around",
      "& div": {
        fontSize: 16
      },
      "& div:first-Child": {
        fontSize: 18
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        "& div, div:first-Child": {
          fontSize: 14
        }
      }
    }
  };
});
